import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { sk } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";

export const SkDatePicker = ({ label, value, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  const d = value ? parseISO(value) : null;
  const valid = d && isValid(d);
  return (
    <div>
      <label className="block text-xs text-white/50 mb-1.5">{label}</label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid}
            className="w-full flex items-center justify-between gap-2 bg-black border border-white/15 px-3 py-2 text-sm text-left focus:border-[#D4AF37] outline-none hover:border-[#D4AF37]/50 transition-colors">
            <span className={valid ? "text-white" : "text-white/35"}>{valid ? format(d, "d. M. yyyy", { locale: sk }) : "Vyberte dátum (dd. mm. rrrr)"}</span>
            <span className="flex items-center gap-2 text-[#D4AF37]">
              {valid && <X size={14} className="text-white/40 hover:text-white" data-testid={`${testid}-clear`}
                onClick={(e) => { e.stopPropagation(); onChange(""); }} />}
              <CalendarDays size={15} />
            </span>
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto p-0 bg-[#0a0a0a] border border-[#D4AF37]/40 text-white" data-testid={`${testid}-popover`}>
          <Calendar mode="single" locale={sk} weekStartsOn={1} selected={valid ? d : undefined} defaultMonth={valid ? d : undefined}
            onSelect={(day) => { if (day) { onChange(format(day, "yyyy-MM-dd")); setOpen(false); } }}
            classNames={{ day_selected: "bg-[#D4AF37] text-black hover:bg-[#D4AF37] hover:text-black focus:bg-[#D4AF37] focus:text-black", day_today: "border border-[#D4AF37]/60 text-[#F2E3C6]" }} />
        </PopoverContent>
      </Popover>
    </div>
  );
};
